import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[uppercase]'
})
export class UppercaseDirective {

  @Input() mostrarUppercase: boolean = true;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    if (this.mostrarUppercase) {
      const input = this.el.nativeElement as HTMLInputElement;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      
      const upperValue = input.value.toLocaleUpperCase('pt-BR');

      if (input.value !== upperValue) {
        input.value = upperValue;
        input.setSelectionRange(start, end);
      }
    }
  }
}